import EnrolmentsAdapter from './base';

export default class Application extends EnrolmentsAdapter {
  modelNamePlural = 'applications';
}
